import React from 'react';
import Icon from 'react-icon-base';

export const TopPort = (props) => (
    <Icon viewBox="0 0 16 8" {...props}>
        <svg
            width="16px"
            height="8px"
            viewBox="0 0 16 8"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <title>connector_top</title>
            <g
                id="Iteration-1.1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="Dialog-blocks---Connections"
                    transform="translate(-504.000000, -108.000000)"
                    fill="#92989B"
                >
                    <g
                        id="Group-4"
                        transform="translate(412.000000, 108.000000)"
                    >
                        <path
                            d="M108,8 C108,3.581722 104.418278,0 100,0 C95.581722,0 92,3.581722 92,8 L108,8 Z"
                            id="connector_top"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    </Icon>
);
